export default __webpack_public_path__ + "assets/ico_next-5791c0f4.svg";